import React from "react";
import * as Yup from "yup";
import { Card } from "@jsq/ds/core";
import { Form } from "@jsq/ds/forms";
import { Column, ColumnContainer } from "@jsq/ds/layouts";
import { DocumentTracker } from "../../../components/DocumentTracker";
import { FormStepFooter } from "../../../components/FormStepFooter";
import { PayeeDetailsBase } from "../../../components/PayeeDetailsBase";
import { PayeeActionTypes, PayeeStepActionTypes } from "../../../Context/constants";
import {
  useBasePayeeReducerContext,
  usePayeeWorkflowDispatchContext,
  usePayeeDispatchContext,
} from "../../../Context/PayeeContext";
import {
  payeeDetailsColumnStyles,
  stepColumnContainerStyles,
  stepContainerStyles,
} from "../../../styles_vanilla.css";

const validationSchema = Yup.object().shape({
  payeeName: Yup.string().required("Payee name is required"),
});

export const InvestmentPayeeDetailsStep: React.FC = () => {
  const stepDispatch = usePayeeWorkflowDispatchContext();
  const payeeDispatch = usePayeeDispatchContext();
  const { supportingDocuments, payeeName } = useBasePayeeReducerContext();

  const documentName = supportingDocuments?.[0]?.name || "";
  const documentUrl = supportingDocuments?.[0]?.localUrl || "";

  return (
    <div className={stepContainerStyles}>
      <Form
        initialValues={{ payeeName: payeeName || "" }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          payeeDispatch({
            type: PayeeActionTypes.SET_PAYEE_DETAILS_ENTITY_AND_INVESTMENT,
            payload: { payeeName: values.payeeName },
          });
          stepDispatch({ type: PayeeStepActionTypes.INCREMENT_STEP });
        }}
        enableReinitialize
      >
        <ColumnContainer className={stepColumnContainerStyles}>
          <Column size={"fluid"}>
            <DocumentTracker documentName={documentName} documentUrl={documentUrl} />
          </Column>
          <Column size={"fluid"} className={payeeDetailsColumnStyles}>
            <Card title="Payee Details">
              <PayeeDetailsBase payeeNameLabel="Investment" />
            </Card>
          </Column>
        </ColumnContainer>
        <FormStepFooter
          onBack={() => {
            stepDispatch({ type: PayeeStepActionTypes.DECREMENT_STEP });
          }}
        />
      </Form>
    </div>
  );
};

export default InvestmentPayeeDetailsStep;
